<template>
    <project-step-container
            prev-to="deep_customer_empathy_5"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
               {{getMessage(6, 'empathy-map-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide  @open-url="openGuide" icon-name="icon-guide" :text="getMessage(6, 'empathy-map-guide')" />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(6, 'perfectWorld')}}</label>
                <textarea id="first-thing" type="text" v-model="form.perfectWorld"
                          aria-label="In a perfect world... Think big, almost impossible  "
                         :placeholder="getMessage(6, 'perfectWorldplaceholder')" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(6, 'benefit')}}</label>
                <textarea id="second-thing" type="text" v-model="form.benefit"
                          aria-label="The biggest benefit to me is... Improvement in customer’s life  "
                         :placeholder="getMessage(6, 'benefitplaceholder')" rows="3"></textarea>

            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(6, 'emotions')}}</label>
                <input id="third-thing" type="text" v-model="form.emotions" :placeholder="getMessage(6, 'emotionsplaceholder')"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide"


    export default {
        name: "DeepCustomerEmpathy6",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_IDEAL_STATE,
                urlNextProject:'go_broad_to_go_narrow_7',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.IDEAL_STATE),
                form: {
                    perfectWorld: "",
                    benefit: "",
                    emotions: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

